import { useEffect, useState } from 'react'
import { RouteObject } from 'react-router'
import { matchPath } from 'react-router-dom';

import { Millisecond } from '@/constants/common';
import { useGetSolPriceUsd } from '@/hooks/services/useTokenPrice'
import router from '@/routes'


// const findMatchedRoutes = (
//   path: string, 
//   routes: any[], 
//   matched: any[] = []
// ) => {
//   for (const route of routes) {
//     if (!route.path) {
//       continue
//     }
//     const match = matchPath(
//       { path: route.path, end: false }, 
//       path
//     );
//     if (match) {
//       matched.push(route);
//       if (route.children?.length > 0) {
//         const remainingPath = path.replace(match.pathname.replace(/\/$/, ''), '') || '/';
//         findMatchedRoutes(remainingPath, route.children, matched);
//       }
//     }
//   }
//   return matched;
// };

const findMatchedRoute = (
  path: string, 
  routes: RouteObject[],
): RouteObject | null => {
  for (const route of routes) {
    if (!route.path || route.path == '*') {
      continue
    }
    const match = matchPath(
      { path: route.path }, 
      path
    );
    if (match) {
      return route
    } else if (route.children?.length) {
      const res = findMatchedRoute(path, route.children);
      if (res) {
        return res;
      }
    }
  }
  return null
};

const useHelper = () => {
  const [interval, setInterval] = useState<number | undefined>()
  useGetSolPriceUsd(interval)
  useEffect(()=>{
    const route = findMatchedRoute(
      window.location.pathname,
      router.routes
    )
    if (!route?.handle?.isCallback) {
      setInterval(Millisecond.MINUTE_1)
    }
  }, [])
}

export default useHelper
